import { useRef } from 'react';
import { popUpConst } from '../../../src/constants/reworkPageTasks';
import { getDiffrencyArray } from '../../../src/Utils/GridService';
import LoadingOverlay from 'react-loading-overlay-ts';
import './index.scss';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import { Toast } from 'primereact/toast';
 
const SelectionPopUp = ({ selectedNodes, unSelectedNodes, onCancellation, loading, updatedSelectedList, onSubmit }) => {
  const toast = useRef(null);
  let selectedTaskIDList = []
  let deSelectedTaskIDList = []
  let deselectedResList = []
 
  const updatedDeselectedList = getDiffrencyArray(unSelectedNodes, selectedNodes);
  //get all IDs of selected node
  updatedSelectedList.forEach((item) => {
    selectedTaskIDList.push(item?.Task_ID)
  })
 
  //get all IDs of De-selected node
  updatedDeselectedList?.forEach((item) => {
    deSelectedTaskIDList.push(item?.Task_ID)
  })
  //push to deselected result only if parent job is selected
  updatedDeselectedList?.forEach((item) => {
    let subsetArray = item?.Dependency?.split(',')
    if (item?.Task_ID) {
      //4053
      // subsetArray?.some((el) => {
      //   if (selectedTaskIDList.includes(el) || deSelectedTaskIDList.includes(el)) {
      //     deselectedResList.push(item)
      //   }
      // })
      deselectedResList.push(item)
    }
  })
  //remove all childern if JOB is unselected // commented this code to fix AWM-2812
  // updatedDeselectedList?.forEach((item) => {
  //   if (!item?.Task_ID) {
  //     const children = getAllChildern(treedata, item)
 
  //     const idsSet = new Set(children.map(obj => obj.key));
  //     for (let i = deselectedResList.length - 1; i >= 0; i--) {
  //       if (idsSet.has(deselectedResList[i].key)) {
  //         deselectedResList.splice(i, 1); // Remove object at index i from deselectedResList
  //       }
  //     }
  //   }
  // })
 
 
  const createDynamicTable = (nodes) => {
    if (nodes?.length) {
      return (
        <table>
          <thead>
            <tr>
              <th>{popUpConst.taskID}</th>
              <th>{popUpConst.task}</th>
            </tr>
          </thead>
          <tbody>
            {nodes?.map((item) => (
              <tr key={item?.Task_ID}>
                <td>{
                  item["Task ID"] !== "" ? item["Task ID"] : item.Task_ID
                }</td>
                <td><span>{item?.Task}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }
  };

  //4053
const filterByPredecessorMatch = (deselectedResList, updatedSelectedList) => {
  const selectedTaskIds = new Set(updatedSelectedList?.map(item => item["Task ID"]));
  const remainingTasks = [...deselectedResList];
  const result = [];
  const resultTaskIds = new Set(); // To ensure uniqueness

  let added;
  do {
      added = false;
      for (let i = remainingTasks?.length - 1; i >= 0; i--) {
          const item = remainingTasks[i];
          const predecessors = item.Predecessor?.split(',') || [];

          if (predecessors?.some(pred => selectedTaskIds.has(pred))) {
              const taskId = item["Task ID"];
              if (!resultTaskIds.has(taskId)) {
                  selectedTaskIds.add(taskId);
                  result.push(item);
                  resultTaskIds.add(taskId);
                  added = true;
              }
              remainingTasks.splice(i, 1); // Remove from remaining
          }
      }
  } while (added);

  return result;
};

  const buttonName = () => {
    const checkCICJob = selectedNodes?.some((item) => item?.code?.includes("RCIC"));
    if (checkCICJob) {
      return popUpConst.next
    }
    return popUpConst.submit
  }

  return (
    <LoadingOverlay active={loading} spinner text="">
      <div className="selectionpopup">
        {<Toast ref={toast} position="top-center" />}
        <div className="headers">
          <p className="headerText">{popUpConst.headerText}</p>
          <p className="infoText">
            <span className="textVal">{popUpConst.textVal}</span>
          </p>
        </div>
        <span className="preHead">{popUpConst.preHeadSel}</span>
        <div className="selectedtasks">{createDynamicTable(updatedSelectedList)}</div>
        <span className="preHead">{popUpConst.preHeadDeSel}</span>
        <div className="deselectedtasks">
          {createDynamicTable(filterByPredecessorMatch(deselectedResList, updatedSelectedList))}
        </div>
        <div className="footerbutton">
          <footer>
            <Button variant="secondary" onClick={() => onCancellation()}>
              {popUpConst.cancel}
            </Button>
            <Button onClick={() => onSubmit()}>{buttonName()}</Button>
          </footer>
 
        </div>
      </div>
    </LoadingOverlay>
  );
};
export default SelectionPopUp;
 